(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nuvora-desktop-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.querySelectorAll('.nv-catalog').forEach(nav => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      nav.querySelectorAll('details').forEach(details => {
        let timer;
        details.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(timer);
          nav.querySelectorAll('details[open]').forEach(other => { if (other !== details) other.open = false; });
          details.open = true;
        });
        details.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          timer = setTimeout(() => { if (!details.contains(document.activeElement)) details.open = false; }, 180);
        });
        details.addEventListener('toggle', () => {
          if (details.open) nav.querySelectorAll('details[open]').forEach(other => { if (other !== details) other.open = false; });
        });
        details.addEventListener('keydown', event => {
          if (event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); event.stopPropagation(); }
        });
        details.addEventListener('focusout', () => {
          requestAnimationFrame(() => { if (!details.contains(document.activeElement) && !details.matches(':hover')) details.open = false; });
        });
      });
    });
  };
  document.addEventListener('click', event => {
    document.querySelectorAll('.nv-catalog details[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
